import { render, staticRenderFns } from "./school_paper.vue?vue&type=template&id=5b0cad5c&"
import script from "./school_paper.vue?vue&type=script&lang=js&"
export * from "./school_paper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports